<template>
    <section class="assessmentSection protectionLevelOverview aocIntroSection">
        <div class="welcomeBackground"></div>
        <div class="pageContent">
            <div class="pageCompleted">70% complete</div>
            <div class="pageTitle">Let’s identify areas of concern in your home.</div>
            <div class="pageText">
                <p>
                    We have a process for helping you protect areas of concern. Before we get started, let’s cover some basics.
                </p>
            </div>
            <continue-button to="/assessment/what-is-area-of-concern" text="Let's get started" :before="mixpanelTracking" />
        </div>
        <!-- Preload images for next section -->
        <div class="preloadImages">
          <img src="/img/aoc-no-intruder.png" class="interactiveImage" alt="" />
          <img src="/img/aoc-explanation.png" class="interactiveImage" alt="" />
        </div>
    </section>
</template>

<script>
  import {
    mapActions,
    mapState
  } from 'vuex'
  export default {
    computed: {
      ...mapState([])
    },
    methods: {
      ...mapActions([]),
      mixpanelTracking() {
        mixpanel.track('startedAoCIntro')
      },
    },
  }
</script>

<style lang="scss">
.preloadImages {
  position: relative;
  img {
    position: absolute;
    opacity: 0;
  }
}
</style>
